export const firebaseConfig = {
    apiKey: "AIzaSyB2-qe1lVv296ZIQlNXo_B50O4QFTXrjFM",
    authDomain: "mazocapital-e5398.firebaseapp.com",
    projectId: "mazocapital-e5398",
    storageBucket: "mazocapital-e5398.appspot.com",
    messagingSenderId: "1078627722234",
    appId: "1:1078627722234:web:fed2a104f5e71954337a43",
    measurementId: "G-SJ8LC6LJ7W"
};